import { updatePageMeta } from '@/utils/seoMeta';

export default {
  install(Vue, options = {}) {
    // 添加全局方法
    Vue.prototype.$updateSEO = updatePageMeta;
    
    // 添加全局混入（可选）
    Vue.mixin({
      created() {
        // 可以在这里添加全局的 SEO 相关逻辑
      }
    });
    
    console.log('SEO Meta 插件已安装');
  }
};